var websites= {
  electronic: {
    name: 'Electronique NewsMag',
    category: 'electronic',
    url: 'electronique-newsmag.com',
  },
  connected_company: {
    name: 'L\'entreprise connectée',
    category: 'connected_company',
    url: 'lentrepriseconnectee.com',
    logo: 'lec-logo-141217.jpg',
  },
  ipe: {
    name: 'IPE NewsMag',
    category: 'ipe',
    url: 'ipe-newsmag.com',
  },
  iot: {
    name: 'IOT NewsMag',
    category: 'iot',
    url: 'iot-newsmag.com',
  },
  ia: {
    name: 'IA NewsMag',
    category: 'ia',
    url: 'ia-newsmag.com',
  },
  security: {
    name: 'Security NewsMag',
    category: 'security',
    url: 'security-newsmag.com',
  },
  cloud: {
    name: 'Cloud NewsMag',
    category: 'cloud',
    url: 'cloud-newsmag.com',
  },
  telecom: {
    name: 'Télécom NewsMag',
    category: 'telecom',
    url: 'telecom-newsmag.com',
  },
};

export default {
  currentWebsite: function() {
    var websiteName = process.env.CURRENT_WEBSITE;
    if (!websites[websiteName]) {
      return null;
    }
    return websites[websiteName];
  },
};



//////////////////
// WEBPACK FOOTER
// ./config/websites.js
// module id = 92Po
// module chunks = 0